import React from "react";
import { PageType, useSdkContext } from "~/components/contexts";
import { useGA4CommonParameters } from "~/components/rosetta/hooks";
import { SubscriptionButton } from "~/components/rosetta/subscription-button/styles";
export const EpaperButton = ({
  className
}) => {
  const {
    currentPageType,
    handleTrackGA,
    handleTrackGA4,
    handleTrackGTM,
    handleTrackMixPanel
  } = useSdkContext();
  const {
    computeGA4CommonParameters
  } = useGA4CommonParameters();
  return /*#__PURE__*/React.createElement(SubscriptionButton, {
    className: className,
    onClick: () => {
      handleTrackMixPanel({
        name: "Subscription Entry Point",
        property: {
          Location: `${currentPageType === PageType.Article ? "Article" : "Homepage"} Masthead`
        }
      });
      const gaEvent = {
        action: "Masthead/Read Epaper",
        category: "Masthead",
        label: window.location.href
      };
      handleTrackGTM({
        event: "epaper-button",
        tracking: gaEvent
      });
      handleTrackGA(gaEvent);
      handleTrackGA4({
        action: "click",
        category: "epaper",
        customized_parameters: {
          call_to_action: "read epaper",
          ...computeGA4CommonParameters(),
          trigger_point: "masthead"
        },
        subcategory: ""
      });
      window.location.href = "/epaper";
    },
    "data-qa": "epaper-button"
  }, "Read ePaper");
};
EpaperButton.displayName = "EpaperButton";